import { createContext } from "react";

import type { Shot } from "../../types/shot.types";

export interface SessionShotsContextValue {
  shots: Shot[];
  sessionId: string;
  startTime: number | null;
  isLoading: boolean;
  consented: boolean;
  endSession: (reason: "manual" | "timeout") => void;
  startNewSession: () => void;
  beginSession: () => void;
  setConsented: (consented: boolean) => void;
  updateShot: (shot: Shot) => void;
  removeShot: (shotId: string) => void;
}

export const SessionShotsContext =
  createContext<SessionShotsContextValue | null>(null);
